module.exports = __webpack_public_path__ + "img/1002.960140a1.png";